import { format } from 'date-fns';
import { appendTimeZone } from 'src/utils/date';
import { getQuestionLabel } from '../../containers/QuestionList/utils';
import { NodeType } from '../../graphql/common/types/node';
function addCrumb(crumbs, label, to) {
    if (!label || label === '__DEFAULT__') {
        return;
    }
    crumbs.push({ label, ...(to && { to }) });
}
export function getEPBreadCrumbs(ancestorsDetails, knownNodes, options = {}) {
    const crumbs = [];
    const community = knownNodes?.community ?? ancestorsDetails?.community;
    const communityTitle = community?.data.title;
    if (communityTitle) {
        addCrumb(crumbs, communityTitle, { screen: 'EP_Home', params: {} });
    }
    const examLevel = knownNodes?.examLevel ?? ancestorsDetails?.examLevel;
    const examLevelTitle = examLevel?.data.title;
    if (examLevelTitle) {
        addCrumb(crumbs, examLevelTitle, examLevel?.id
            ? { screen: 'EP_Home', params: { examLevelID: examLevel.id } }
            : undefined);
    }
    const subject = knownNodes?.subject ??
        ancestorsDetails?.writtenSubject ??
        ancestorsDetails?.oralsSubject;
    const subjectTitle = subject?.data.title;
    if (subjectTitle) {
        addCrumb(crumbs, subjectTitle, subject?.id ? {
            screen: 'EP_Subject',
            params: { subjectID: subject.id },
        } : undefined);
    }
    const topic = knownNodes?.topic;
    if (topic) {
        addCrumb(crumbs, topic, subject?.id ? {
            screen: 'EP_TopicQuestions',
            params: {
                ancestorID: subject.id,
                topic,
            },
        } : undefined);
    }
    const qp = ancestorsDetails?.writtenQP ?? ancestorsDetails?.oralsQP ?? knownNodes?.qp;
    const qpTo = qp?.id
        ? {
            screen: 'EP_QP',
            params: { qpID: qp.id },
        }
        : undefined;
    if (qp?.type === NodeType.ORALS_QP) {
        const dateLabel = format(new Date(appendTimeZone(qp.data.dateNL)), 'MMM yyyy');
        addCrumb(crumbs, dateLabel, qpTo);
    }
    addCrumb(crumbs, qp?.data?.label, qpTo);
    const question = knownNodes?.question;
    if (question) {
        addCrumb(crumbs, getQuestionLabel(question));
    }
    return options.visibleCount
        ? crumbs.slice(-options.visibleCount)
        : crumbs;
}
export default function getBreadCrumbs(ancestorsDetails, knownNodes, options = {}) {
    return getEPBreadCrumbs(ancestorsDetails, knownNodes, options).map(crumb => crumb.label);
}
